function normalizeSrc(src: string): string {
    return src.startsWith('/') ? src.slice(1) : src
}

// Docs: https://developers.cloudflare.com/images/transform-images
export default function cloudflareImageUrl({ src, width, quality }: { src: string; width: number; quality?: number }) {
    const params = [`width=${width}`, `quality=${quality || 85}`, 'format=auto']
    const imageDomain = 'qz.com'

    return `https://${imageDomain}/cdn-cgi/image/${params.join(',')}/${normalizeSrc(src)}`
}
